import { Box } from '@cad-arc';
import { Resizable } from 're-resizable';
import { EventPanelTab, tabComponents } from './event-panel-tabs-config';
import { TabNotificationsDismisser } from './tab-notifications-dismisser';

export function InlineModeActiveTab({ activeTab }: { activeTab: EventPanelTab }) {
    const TabComponent = tabComponents[activeTab];
    return (
        <Resizable
            enable={{
                top: true,
            }}
            defaultSize={{
                width: '100%',
                height: 300,
            }}
            minHeight={50}
            maxHeight={580}
        >
            <Box
                w="100%"
                h="100%"
                borderTop="sm"
                borderColor="border.default"
                bg="surface.canvas"
            >
                <>
                    <TabNotificationsDismisser tab={activeTab} />
                    <TabComponent />
                </>
            </Box>
        </Resizable>
    );
}
